<template>
  <div id="detail">
    <div class="general-header container">
      <h3 class="cate-title">新闻中心</h3>
      <div class="visible-xs" style="clear:both;"></div>
      <el-breadcrumb separator=">">
              <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/news' }">新闻中心</el-breadcrumb-item>
        <el-breadcrumb-item >{{server.name}}</el-breadcrumb-item>
            </el-breadcrumb>
    </div>
    <div class="article container">
      <h2 class="article-title">{{server.name}}</h2>
      <p class="article-info"><span class="article-data">时间：{{server.data}}</span><span>来源：{{server.from}}</span></p>
      <div v-html="articleList"></div>
    </div>
  </div>
</template>

<script>
  import Daily from '../../assets/data/news.js';

  export default {
    name: "server-detail",
    data(){
      return{
        kind:'',
        detail:[],
        articleList:[],
        server:{},
      }
    },
    created() {
      this.filterKind()
    },
    watch: {
      $route(){
        this.filterKind()
      }
    },
    methods:{
      filterKind(){
        this.kind = this.$route.params.id;
        this.detail = Daily.news;
        var detailS = Daily.detail;
        for(var i=0;i<this.detail.length;i++){
          if(this.detail[i].id === this.kind){
            this.server = Daily.news[i];
            if(detailS[i]){
              this.articleList = detailS[i].article;
            }
          }
        }
      },
    }
  }
</script>

<style scoped lang="less">
  #detail{
    .general-header{
      border-bottom: 1px solid #dddddd;
      padding-top: 31px;
      padding-bottom: 31px;
      .cate-title{
        display: inline-block;
        width: 210px;
        margin:0;

      }
      .el-breadcrumb{
        padding: 0 10px;
        vertical-align: bottom;
        display: inline-block;
      }
    }
    .article{
      padding: 30px 20px;
      .article-title{
        font-size: 26px;
        font-weight: bold;
        margin-bottom: 16px;
      }
      .article-info{
        margin-bottom: 14px;
        color:#bbbbbb;
        text-align: center;
        .article-data{
          margin-right: 50px;
        }
      }
      .article-list{
        line-height: 28px;
        font-size: 18px;
        .content{
          margin-bottom: 20px;
        }
        .title{
          margin-bottom: 5px;
          font-weight: bold;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/page/news-detail.vue